const tmp = typeof settings === "undefined" ? {} : settings;

export default _.map(_.get(tmp, 'filter', []), (filter) => filter.url.substring(1, filter.url.length - 1));
